module.exports = __webpack_public_path__ + "img/k-2.5a2ceb6c.png";